import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import File from '@/plugins/sdk/resources/File'

export default class extends Resource {
  static name = 'attachment'

  static get fields () {
    return {
      id: new UUID(),
      resource: new STRING(),
      resource_uuid: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      file: new ITEM(File)
    }
  }
}
